import { useEffect, useRef } from "react";
import { Dialog } from "@actinc/dls";
import { ControlledFormEditor } from "../ControlledFormEditor";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
const BankedItemSaveDialog = ({ onClose = () => {}, open }) => {
  const editorRef = useRef(null);
  const methods = useForm({
    mode: "onChange",
    defaultValues: {
      notes: "",
    },
  });

  const {
    control,
    getValues,
    reset,
    trigger,
    formState: { isValid },
  } = methods;

  useEffect(() => {
    if (!open) return;
    reset({ notes: "" });
    editorRef.current?.data.set("<p></p>");
    trigger("notes");
  }, [open, reset, trigger]);

  const handleClose = () => () => {
    onClose("");
  };
  const handleContinue = () => () => {
    const notes = getValues("notes");
    onClose(notes);
  };
  return (
    <Dialog open={open} onClose={handleClose()}>
      <DialogTitle>Enter Comment</DialogTitle>
      <DialogContent>
        <FormProvider {...methods}>
          <ControlledFormEditor
            control={control}
            fullWidth={true}
            id={`notes`}
            label="Comments"
            name={`notes`}
            options={["taskComments"]}
            rules={{
              required: true,
              validate: (value) => {
                const plainText = value?.replace(/<[^>]*>/g, "").trim();
                return plainText?.length > 0 || "Notes are required";
              },
            }}
            defaultValue={""}
            onReady={(ed) => {
              editorRef.current = ed;
            }}
          />
        </FormProvider>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose()}>CANCEL</Button>
        <Button disabled={!isValid} onClick={handleContinue()}>
          CONTINUE
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export { BankedItemSaveDialog };
